import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from './translation.service'; // new

@Pipe({
  name: 'trans',
  pure: true,
  standalone: true
})
export class TransPipe implements PipeTransform {
  constructor(private translationService: TranslationService) {}

  transform(key: string): string {
    return this.translationService.translate(key);
  }
}

